class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.onToggleClick = this.onToggleClick.bind(this);
        this.onDrawerClick = this.onDrawerClick.bind(this);
        this.isBound = false;
    }

    connectedCallback() {
        if (this.isBound) {
            return;
        }

        this.cartDrawerToggle = document.querySelector('.section-header-cart-drawer-toggle');

        if (this.cartDrawerToggle) {
            this.cartDrawerToggle.addEventListener('click', this.onToggleClick);
        }

        this.addEventListener('click', this.onDrawerClick);
        this.isBound = true;
    }

    disconnectedCallback() {
        if (!this.isBound) {
            return;
        }

        if (this.cartDrawerToggle) {
            this.cartDrawerToggle.removeEventListener('click', this.onToggleClick);
        }

        this.removeEventListener('click', this.onDrawerClick);
        this.isBound = false;
    }

    onToggleClick(event) {
        event.preventDefault();
        this.open();
    }

    onDrawerClick(event) {
        if (
            event.target.closest('.cart-drawer-close') ||
            event.target.closest('.cart-drawer-overlay') ||
            event.target.closest('.cart-drawer-empty-footer')
        ) {
            event.preventDefault();
            this.close();
        }
    }

    open() {
        document.documentElement.classList.add('cart-drawer-open', 'overflow-hidden');
        document.body.classList.add('cart-drawer-open', 'overflow-hidden');
        this.classList.add('active');
    }

    close() {
        document.documentElement.classList.remove('cart-drawer-open', 'overflow-hidden');
        document.body.classList.remove('cart-drawer-open', 'overflow-hidden');
        this.classList.remove('active');
    }
}

if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
}
